import React from 'react';

import moment from 'moment';

import BobCancelButton from '../../../components/BobCancelButton';
import BobModal from '../../../components/BobModal';

import * as classes from './HealthInfoModal.module.css';

// eslint-disable-next-line no-unused-vars
import { getTimeZoneAbbr } from '../../../helpers/timezones';

const HealthInfoModal = ({
    onCloseModal,
    ruleDetails,
    selectedHealthCheck,
    setHealthInfoModalOpen,
    type,
    ...props
}) => {
    // eslint-disable-next-line no-unused-vars
    const zone = moment.tz.guess();

    const closeModal = () => {
        if (type && type === 'RuleInfoModal') {
            onCloseModal();
        } else {
            setHealthInfoModalOpen(false);
        }
    };

    let entityData = selectedHealthCheck;

    if (type && type === 'RuleInfoModal') {
        entityData = ruleDetails;
    }
    
    return (
        <BobModal
            title={'Rule Information'}
            hidebuttons={true}
            headerOverride={classes.HeaderOverride}
            isRemoveFooter={true}
            onClose={() => closeModal()}
        >
            <div className={classes.HealthInfoModal}>
                <div className={classes.Label}>
                    Rule:
                </div>
                <div>
                    {entityData.name}
                </div>
                <div className={classes.Label}>
                    Description:
                </div>
                <div>
                    {entityData.description}
                </div>
                <div className={classes.Label}>
                    Issue Types:
                </div>
                <div>
                    {entityData.issueTypes.join(', ')}
                </div>
                <div className={classes.Label}>
                    Target:
                </div>
                <div>
                    { type === 'RuleInfoModal' ? entityData.target : entityData.snapshotRoute}
                </div>
                <div className={classes.Label}>
                    Status:
                </div>
                <div>
                    { entityData.currentStatus ?
                        entityData.currentStatus :
                        entityData.status === true ? 'Fault' : 'Ok'
                    }
                </div>
                {entityData.timestamp ?
                    <div className={classes.Label}>
                        Last Successful Execution:
                    </div> : null
                }
                {entityData.timestamp ?
                    <div>
                        {moment(entityData.timestamp).format('YYYY-MM-DD hh:mm A') + ' ' + getTimeZoneAbbr(entityData.timestamp, zone)}
                    </div>
                    : null
                }
                <div className={classes.Label}>
                    System Effect:
                </div>
                <div>
                    {entityData.systemEffect}
                </div>
                <div className={classes.Label}>
                    Recommendation:
                </div>
                <div>
                    {entityData.recommendation}
                </div>
            </div>
            <div className={classes.ButtonContainer}>
                <BobCancelButton
                    onClick={() => closeModal()}
                    className={classes.CancelButton}
                    label={'Close'}
                />
            </div>
        </BobModal>
    );
};

export default HealthInfoModal;
